module.exports = __webpack_public_path__ + "static/media/icon_button1_b.37488a0f.svg";